import { useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
    validatePageInput,
    appendPageChar,
    pageErrorText,
} from "./pageRange";

const buttonVariants = {
    rest: { scale: 1, y: 0 },
    hover: { scale: 1.05, y: -2, transition: { duration: 0.2, ease: "easeOut" } },
    tap: { scale: 0.95, transition: { duration: 0.1, ease: "easeIn" } },
};

function NumberKeyboard({ value, onChange, onConfirm, maxPage = null }) {
    const [error, setError] = useState("");
    const { t } = useTranslation();
    const buttons = [
        "1", "2", "3",
        "4", "5", "6",
        "7", "8", "9",
        "-", "0", ",",
        "Очистить", "Подтвердить", "Закрыть",
    ];

    const handleButtonClick = (btn) => {
        if (btn === "Очистить") {
            onChange(value.slice(0, -1));
            setError("");
            return;
        }

        if (btn === "Закрыть") {
            onConfirm();
            return;
        }

        if (btn === "Подтвердить") {
            const result = validatePageInput(value, maxPage);
            if (!result.valid) {
                setError(pageErrorText(t, result.code, result.params));
                return;
            }
            if (result.cleaned !== value.trim()) {
                onChange(result.cleaned); // подчищаем висящий разделитель
            }
            setError("");
            onConfirm();
            return;
        }

        // --- ввод цифр и разделителей ---
        const result = appendPageChar(value, btn);
        if (result.code) {
            setError(pageErrorText(t, result.code));
            return;
        }

        setError("");
        onChange(result.value);
    };

    const getButtonStyle = (btn) => {
        if (btn === "Очистить") return "bg-gray-200 text-gray-800";
        if (btn === "Подтвердить") return "bg-gradient-to-r from-blue-500 to-teal-500 text-white";
        if (btn === "Закрыть") return "bg-gray-300 text-gray-700";
        return "bg-gradient-to-r from-blue-400 to-blue-500 text-white";
    };

    return (
        <div className="fixed bottom-0 left-0 w-full bg-gray-100 rounded-t-xl shadow-lg p-4 z-30">
            {error && (
                <p className="text-center text-red-500 text-[1.8vh] font-medium mb-2">
                    {error}
                </p>
            )}
            <div className="grid grid-cols-3 gap-2">
                {buttons.map((btn) => (
                    <motion.button
                        key={btn}
                        variants={buttonVariants}
                        initial="rest"
                        whileHover="hover"
                        whileTap="tap"
                        className={`${getButtonStyle(btn)} font-bold text-[2vh] rounded-lg p-4 shadow-md flex items-center justify-center transition-colors duration-150`}
                        onClick={() => handleButtonClick(btn)}
                    >
                        {btn}
                    </motion.button>
                ))}
            </div>
        </div>
    );
}

export default NumberKeyboard;